export default __webpack_public_path__ + "static/media/010_photo.2eb8c88a.jpg";